import React, { useEffect, useRef, useState } from "react";
import {
  GridComponent,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Inject,
  Resize,
  Edit,
  Sort,
  CommandColumn,
  Filter,
  Toolbar,
  ExcelExport,
  ForeignKey,
} from "@syncfusion/ej2-react-grids";
import { getValue } from "@syncfusion/ej2-base";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { auth, cicassService } from "../../../../_services";
import { withTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";
import AnaTruckMobileCard from "./AnaTruckMobileCard";
import { Typography, Box} from "@mui/material";

const editSettings = {
  allowEditing: true,
  allowAdding: true,
  allowDeleting: true,
  mode: "Dialog",
  dialog: { enableResize: true },
  showDeleteConfirmDialog: true,
};
const editSettingsReduced = {
  allowEditing: false,
  allowAdding: false,
  allowDeleting: false,
  mode: "Dialog",
  dialog: { enableResize: true },
  showDeleteConfirmDialog: true,
};
const filterSettings = { type: "CheckBox" };

const commands = [
  { type: "Edit", buttonOption: { iconCss: "e-icons e-edit", cssClass: "e-flat" } },
  { type: "Delete", buttonOption: { iconCss: "e-icons e-delete", cssClass: "e-flat" } },
  { type: "Save", buttonOption: { iconCss: "e-icons e-update", cssClass: "e-flat" } },
  { type: "Cancel", buttonOption: { iconCss: "e-icons e-cancel-icon", cssClass: "e-flat" } },
  { type: "OpenGoogleSheet", buttonOption: { iconCss: 'e-icons e-CSV_Export', cssClass: 'e-flat' } },
];
const commandsReduced = [
  { type: "OpenGoogleSheet", buttonOption: { iconCss: 'e-icons e-CSV_Export', cssClass: 'e-flat' } },
];

const toolbarOptions = ["Search", "Add", "ExcelExport", "Print", {
  text: "Refresh",
  tooltipText: "Refresh",
  prefixIcon: "e-MT_reload",
  id: "forceRefresh",
},];

const AnaTruckPage = ({ t }) => {
  const [myData, setMyData] = useState([]);
  const [fuelTypeData] = useState([
    { id: 'BENZINA', name: 'Benzina' },
    { id: 'DIESEL', name: 'Diesel' }
  ]);
  const [isCicass, setIsCicass] = useState(false);
  const [isAdminOrManager, setIsAdminOrManager] = useState(false);
  const [visibleOnGrid, setVisibleOnGrid] = useState(false);
  const [toastInfo, setToastInfo] = useState({
    title: "",
    content: "Operation completed successfully",
    cssClass: "e-toast-success",
    icon: "e-success toast-icons",
  });

  const isMobile = useMediaQuery('(max-width:600px)');
  const gridInstance = useRef(null);
  const toastRef = useRef(null);
  const apiUrl = "anatruck";

  useEffect(() => {
    const fetchData = async () => {
      const myRole = auth.getUserRole();
      const { data } = await cicassService.getAll(apiUrl);
      setMyData(data);
      //console.log("Ruolo attuale:", myRole);
      setIsCicass(myRole === "SuperUser");
      setIsAdminOrManager(myRole === "Admin" || myRole === "Manager" || myRole === "SuperUser" );
    };
    fetchData();
  }, []);

  const refreshGrid = async () => {
    try {
      const { data } = await cicassService.getAll(apiUrl);
      setMyData(data);
    } catch (error) {
      console.error("Error refreshing grid: ", error);
    }
  };

  const showToast = (type, msg) => {
    const toast = {
      title: type,
      content: msg,
      cssClass: `e-toast-${type.toLowerCase()}`,
      icon: `e-${type.toLowerCase()} toast-icons`,
    };
    setToastInfo(toast);
    toastRef.current.show();
  };

  const toolbarClick = (args) => {
    if (args.item.id === "gridcomp_excelexport") {
      gridInstance.current.excelExport();
    } else if (args.item.id === "forceRefresh") {
      refreshGrid();
    }
  };

  const actionBegin = (state) => {
    if (state.requestType === "beginEdit" || state.requestType === "add") {
      if (state.requestType === "add") {
        state.data = {
          ...state.data,
          id: -1,
          chassisNumber: "",
          viewOrder: 1,
          registrationYear: 1990,
          mileage: 0,
          fuelCapacity: 0,
          vehicleType: "",
          brand: "",
          model: "",
          fuelType: "",
          anaAgencyId: auth.getAgencyId(),
          googleSheetLink: "",
          notes: "",
          insuranceDetails: ""
        };
      }
      setVisibleOnGrid(true);
    }
  };

  const actionComplete = (state) => {
    const handleResult = async (promise, msgPrefix) => {
      try {
        await promise;
        showToast("Success", t("toastSuccess"));
      } catch (err) {
        console.error(`Error on ${msgPrefix}: `, err);
        showToast("Error", `${msgPrefix}: ${err.message}`);
      } finally {
        refreshGrid();
      }
    };

    if (state.requestType === "add" || state.requestType === "beginEdit") {
      state.dialog.enableResize = true;
      state.dialog.width = 600;
      state.dialog.height = 800;
    }
    if (state.action === "add") {
      state.data.id = -1;
      state.data.createdAt = new Date();
      if(state.data.brand === undefined)
        state.data.brand = ""
      if(state.data.chassisNumber === undefined)
        state.data.chassisNumber = ""
      if(state.data.fuelType === undefined)
        state.data.fuelType = "BENZINA"
      if(state.data.insuranceDetails === undefined)
        state.data.insuranceDetails = ""
      if(state.data.mileage === undefined || state.data.mileage === null)
        state.data.mileage = 0
      if(state.data.registrationYear == undefined)
        state.data.registrationYear = 0
      if(state.data.viewOrder === undefined)
        state.data.viewOrder = -1
      state.data.anaAgencyId = auth.getAgencyId()
      handleResult(cicassService.saveOp(apiUrl, state.data), "I");
    }
    if (state.action === "edit") {
      handleResult(cicassService.saveOp(apiUrl, state.data), "U");
    }
    if (state.requestType === "delete") {
      handleResult(cicassService.deleteOp(apiUrl, state.data[0].id), "D");
    }
    setVisibleOnGrid(false);
  };

  const editDate = (field, placeholder) => (args) => (
    <DatePickerComponent
      value={getValue(field, args)}
      id={field}
      placeholder={t(placeholder)}
      floatLabelType="Always"
      format="dd/MM/yyyy"
      locale="it"
    />
  );

  const commandClick = (args) => {
    if (args.target.id?.startsWith("gridcompOpenGoogleSheet")) {
      const link = args.rowData.googleSheetLink;
      if (link) window.open(link, "_blank");
      else showToast("Warning", "Nessun link disponibile");
    }
  };

  const validationRules = { required: true };

  return (
    <>
      <div style={{ margin: "1%", marginTop: "1%" }}>
        <Typography variant="h6" component="h2">{t("AnaTruckPage")}</Typography>
      </div>
      <Box sx={{ p: 2, flex: '1 1 auto' }}>
        {isMobile ? (
          <AnaTruckMobileCard
            data={myData}
            t={t}
            isCicass={isCicass}
            isAdminOrManager={isAdminOrManager}
            visibleOnGrid={visibleOnGrid}
        />
        
        ) : (
          <GridComponent
            id="gridcomp"
            ref={gridInstance}
            dataSource={myData}
            toolbar={toolbarOptions}
            editSettings={isAdminOrManager ? editSettings : editSettingsReduced}
            allowResizing
            allowFiltering
            filterSettings={filterSettings}
            allowPaging
            pageSettings={{ pageSize: 10, pageCount: 5 }}
            allowExcelExport
            actionComplete={actionComplete}
            actionBegin={actionBegin}
            toolbarClick={toolbarClick}
            locale="it"
            allowSorting
            allowRowDragAndDrop
            commandClick={commandClick}
          >
            <ColumnsDirective>
              <ColumnDirective field="id" headerText={t("id")} isPrimaryKey={true} allowEditing={false} visible={isCicass} />
              <ColumnDirective field="name" headerText={t("CriCode")} validationRules={validationRules} />
              <ColumnDirective field="licensePlate" headerText={t("LicensePlate")} validationRules={validationRules} />
              <ColumnDirective field="vehicleType" headerText={t("VehicleType")} visible={visibleOnGrid} />
              <ColumnDirective field="brand" headerText={t("Brand")} />
              <ColumnDirective field="model" headerText={t("Model")} />
              <ColumnDirective field="registrationYear" headerText={t("RegistrationYear")} textAlign="Right" visible={visibleOnGrid} />
              <ColumnDirective field="chassisNumber" headerText={t("chassisNumber")} visible={visibleOnGrid} />
              <ColumnDirective field="mileage" headerText={t("Mileage")} textAlign="Right" visible={visibleOnGrid} />
              <ColumnDirective field="fuelType" headerText={t("FuelType")}
                foreignKeyValue="name"
                foreignKeyField="id"
                dataSource={fuelTypeData}
                validationRules={validationRules}
              />
              <ColumnDirective field="fuelCapacity" headerText={t("fuel_capacity")} textAlign="Right" visible={visibleOnGrid} />
              <ColumnDirective field="lastMaintenanceDate" headerText={t("last_maintenance_date")} type="date" format={"dd/MM/yyyy"} editTemplate={editDate("lastMaintenanceDate", "last_maintenance_date")} visible={visibleOnGrid} />
              <ColumnDirective field="nextMaintenanceDate" headerText={t("next_maintenance_date")} type="date" format={"dd/MM/yyyy"} editTemplate={editDate("nextMaintenanceDate", "next_maintenance_date")} visible={visibleOnGrid} />
              <ColumnDirective field="insuranceDetails" headerText={t("insurance_details")} visible={visibleOnGrid} />
              <ColumnDirective field="insuranceExpiryDate" headerText={t("insurance_expiry_date")} type="date" format={"dd/MM/yyyy"} editTemplate={editDate("insuranceExpiryDate", "insurance_expiry_date")} visible={visibleOnGrid} />
              <ColumnDirective field="revisionDate" headerText={t("revision_date")} type="date" format={"dd/MM/yyyy"} editTemplate={editDate("revisionDate", "revision_date")} visible={visibleOnGrid} />
              <ColumnDirective field="viewOrder" headerText={t("viewOrder")} textAlign="Right" visible={isCicass} />
              <ColumnDirective field="googleSheetLink" headerText={t("link")} visible={visibleOnGrid} />
              <ColumnDirective field="notes" headerText={t("notes")} visible={isAdminOrManager} />
              <ColumnDirective headerText={t("operationOnGrid")} width="150" commands={isAdminOrManager ? commands : commandsReduced}></ColumnDirective>
            </ColumnsDirective>
            <Inject services={[Resize, Filter, Page, Toolbar, Edit, CommandColumn, ForeignKey, ExcelExport, Sort]} />
          </GridComponent>
        )}

        <ToastComponent
          ref={toastRef}
          id="toast_default"
          position={{ X: "Right", Y: "Bottom" }}
          title={toastInfo.title}
          content={toastInfo.content}
          cssClass={toastInfo.cssClass}
          icon={toastInfo.icon}
        />
      </Box>
    </>
  );
};

export default withTranslation()(AnaTruckPage);
